import { createRoot } from "react-dom/client";
import ToastSelector from "./ToastSelector";

const initToasts = () => {
	const notifications = window["toastNotifications"] || [];

	if (notifications.length === 0) return;

	const bodyNode = document.querySelector("body");
	const toastContainerNode = document.querySelector("div.toast-container");

	if (!toastContainerNode && bodyNode) {
		const rootNode = document.createElement("div");
		rootNode.className = "toast-container";

		bodyNode.append(rootNode);
		const root = createRoot(rootNode);
		root.render(
			<div>
				{notifications.map((notification, index) => (
					<ToastSelector
						key={`toast-${index}`}
						componentProps={notification.componentProps}
						toastType={notification.toastType}
						trigger={notification.trigger}
						duration={notification.duration}
						distance={notification.distance}
					/>
				))}
			</div>
		);
	}
};

export default initToasts;
